// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  return (
    <img
      src="https://snugglescript.s3.us-east-1.amazonaws.com/public/logo.png"
      alt="SnuggleScript"
      width={32}
      height={32}
      style={{ borderRadius: 8 }}
    />
  );
}
